module.exports = __webpack_public_path__ + "img/chara02_sp.74558d62.png";